export const getLang = (state) => state.lang;
